import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import ConfirmProvider from './ConfirmContext';
import Payment from './Payment';

const App = () => {
  return (
    <ConfirmProvider>
      <div style={{ height: '100vh' }}>
        <Router>
          <Routes>
            <Route path="/" element={<Login setLoggedIn={() => {}} />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/payment" element={<Payment />} />
          </Routes>
        </Router>
      </div>
    </ConfirmProvider>
  );
};

export default App;
